import { CampaignNameRequiredRule } from '../Rules';
import { CampaignInfo, DomainRule } from '../types';
import { ValidationStrategy } from './ValidationStrategy';
import { WebsiteContentMessage } from '../../../../../types';
import { SegmentDatesAreWithinCampaignDates } from '../Rules/Scheduling/SegmentDatesWithinCampaignDates';
import { SegmentTimesAreValid } from '../Rules/Scheduling/SegmentTimesAreValid';

export class SaveStrategy implements ValidationStrategy {
  public constructor(private campaignInfo: CampaignInfo, private onsiteMessages?: Array<WebsiteContentMessage>) {}

  public validate(): DomainRule[] {
    const rules = [CampaignNameRequiredRule({ name: this.campaignInfo.name })];
    if (this.onsiteMessages && this.onsiteMessages.length) {
      rules.push(SegmentDatesAreWithinCampaignDates(this.campaignInfo.scheduling, this.onsiteMessages));
      rules.push(SegmentTimesAreValid(this.onsiteMessages));
    }

    return rules.filter(s => s.result === 'fail');
  }
}
